<div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: 400px;">
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
    {{'player_details'|GetLabelPipe}}
    <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="when-fx-layout-broke"
                      style="min-height: 250px; max-height: 45vh;">
    <div class="event-view-content event-view-content-first-row" style="justify-content: flex-start;">
      <div class="flex-column-center" style="width: 100%;">
        <div class="flex-row-center flex-justify-space-around" style="width: 100%;">
          <div matRipple class="profile-left-button flex-column-center column-button"
               [class.faded]="true">
            <mat-icon>comment</mat-icon>
            <div>{{'kontakt' | GetLabelPipe}}</div>
          </div>
          <div class="event-user-icon flex-row-center bigger-badge-popup" style="margin-top: 12px;"
               matBadge="{{profile.cup_position}}" matBadgeColor="accent">
            <img src="{{profile.picture_src_preview}}"
                 alt="{{profile.shipping_name}}" title="{{profile.shipping_name}}"
                 style="{{ profile.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
            />
          </div>
          <div matRipple class="profile-right-button flex-column-center column-button"
               [class.faded]="true">
            <mat-icon>account_box</mat-icon>
            <div>{{'account' | GetLabelPipe}}</div>
          </div>
        </div>
        <div class="user-name">
          {{profile.shipping_name}}
        </div>
      </div>
      <ng-container *ngIf="state === 'default'">
        <ng-container>
          <br>
          <div class="infoText" [innerHTML]="'cup_player_qualification_position' | GetLabelPipe : -1:null:[profile.cup_position]"></div>
        </ng-container>
        <br>
      </ng-container>
      <ng-container>
        <br>
        <div class="internal-spinner" *ngIf="state === 'loading'">
          <svg class="spinner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
          </svg>
        </div>
      </ng-container>
      <div *ngIf="state === 'error'">
        >.< error.
      </div>
    </div>

  </mat-dialog-content>
  <div *ngIf="justConfirmed" style="margin-bottom: 10px;" fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="10px">
    <div style="padding: 10px;" class="border-color-green">
      <ng-container *ngIf="gameToDisplay['gamePayload']['status'] == 'confirmed'">✅ {{'cup_game_just_confirmed'|GetLabelPipe}}</ng-container>
      <ng-container *ngIf="gameToDisplay['gamePayload']['status'] == 'walkover'">❌ {{'cup_game_just_walkovered'|GetLabelPipe}}</ng-container>
    </div>
  </div>
  <div *ngIf="errMsg" style="margin-bottom: 10px;" fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="10px">
    <div style="border: 1px solid red; border-radius: 4px; padding: 10px;">
      ⚠️ {{errMsg}}
    </div>
  </div>
  <div *ngIf="pendingRequest" style="margin-bottom: 30px;" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
    <div class="internal-spinner" style="width: 50px; height: 50px;">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
      </svg>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="10px">
    <ng-container *ngIf="profile.call_game_description == 'player_available'">
      <button class="widerButton font16" mat-raised-button color="accent" type="button"
              (click)="createGameClick()"
              [disabled]="pendingRequest">
        {{'cup_action_start_game'|GetLabelPipe}}
      </button>
    </ng-container>
    <ng-container *ngIf="profile.call_game_description == 'mutual_game_in_progress'">
      <button class="widerButton font16" mat-raised-button color="accent" type="button"
              (click)="enterScoreClick()"
              [disabled]="pendingRequest">
        {{'cup_action_enter_score'|GetLabelPipe}}
      </button>
      <button class="widerButton font16" mat-raised-button color="warn" type="button"
              (click)="walkoverClick()"
              [disabled]="pendingRequest">
        {{'cup_action_walkover_game'|GetLabelPipe}}
      </button>
    </ng-container>
    <ng-container *ngIf="profile.call_game_description == 'mutual_game_in_confirmation_vizavi_proposal'">
      <button class="widerButton font16" mat-raised-button color="accent" type="button"
              (click)="confirmScoreClick()"
              [disabled]="pendingRequest">
        {{'cup_action_confirm_game'|GetLabelPipe}}
      </button>
      <button class="widerButton font16" mat-raised-button color="warn" type="button"
              (click)="enterScoreClick()"
              [disabled]="pendingRequest">
        {{'cup_action_change_score2'|GetLabelPipe}}
      </button>
    </ng-container>
    <ng-container *ngIf="profile.call_game_description == 'mutual_game_in_confirmation_my_proposal'">
      <button class="widerButton font16" mat-raised-button color="warn" type="button"
              (click)="enterScoreClick()"
              [disabled]="pendingRequest">
        {{'cup_action_change_score'|GetLabelPipe}}
      </button>
      <button class="widerButton font16" mat-raised-button color="warn" type="button"
              (click)="walkoverClick()"
              [disabled]="pendingRequest">
        {{'cup_action_walkover_game'|GetLabelPipe}}
      </button>
    </ng-container>
  </div>
  <ng-container *ngIf="gameToDisplay">
    <br>
    <div class="infoText">🎾 {{(profile.has_active_game ? 'cup_active_game' : 'cup_last_game') | GetLabelPipe}}: {{gameToDisplay['gamePayload']['profiles'][0]['shipping_name']}} - {{gameToDisplay['gamePayload']['profiles'][1]['shipping_name']}}</div>
    <div class="infoText" *ngIf="gameToDisplay['gamePayload']['score']">{{'cup_game_score' | GetLabelPipe}}: {{gameToDisplay['gamePayload']['score']}}</div>
    <!-- todo: show result: walkover - for all, win/lose for mutual -->
    <div class="infoText" *ngIf="profile.has_active_game">{{'cup_game_deadline' | GetLabelPipe}} <b>{{gameToDisplay['gamePayload']['deadline']*1000|fsDate}}</b></div>
  </ng-container>
  <ng-container>
    <br>

    <div class="flex-row-center flex-justify-center" *ngIf="profile.id == application.user.id">
      <b>{{'cup_profile_status' | GetLabelPipe}}</b>
    </div>
    <div class="flex-row-center flex-justify-center" *ngIf="profile.id != application.user.id">
      <b>{{'cup_vizavi_status' | GetLabelPipe}}</b>
    </div>
    <div class="subrow subrow-trainer flex-row-center whitespace-normal infoText flex-justify-center">
      <div *ngIf="['cup_not_started','cup_closed'].includes(profile.call_game_description)">
        {{'cup_player_registered' | GetLabelPipe}}
      </div>

      <div *ngIf="['me_not_registered','me_quit','me_banned'].includes(profile.call_game_description)">
        <ng-container *ngIf="profile.has_active_game">
          {{'cup_player_busy' | GetLabelPipe}}
        </ng-container>
        <ng-container *ngIf="profile.id == application.user.id && !listItem.itemFullData.has_active_game">
          {{('my_incomplete_status__'+listItem.itemFullData.call_game_description) | GetLabelPipe}}
        </ng-container>
        <ng-container *ngIf="profile.id != application.user.id && !listItem.itemFullData.has_active_game">
          {{('cup_player_free_but__'+listItem.itemFullData.call_game_description) | GetLabelPipe}}
        </ng-container>
      </div>

      <div *ngIf="['self_skip'].includes(profile.call_game_description)">
<!--        <ng-container *ngIf="profile.has_active_game">-->
<!--          {{'cup_your_position' | GetLabelPipe}}-->
<!--          <div style="height: 5px;"></div>-->
<!--          {{'cup_active_game' | GetLabelPipe}}: {{profile.games[0]['gamePayload']['profiles'][0]['shipping_name']}} - {{profile.games[0]['gamePayload']['profiles'][1]['shipping_name']}}-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="!profile.has_active_game">-->
<!--          {{'cup_your_position' | GetLabelPipe}}-->
<!--        </ng-container>-->
        <ng-container *ngIf="!profile.has_active_game">
          {{'cup_you_are_free' | GetLabelPipe}}
        </ng-container>
      </div>

      <div *ngIf="['player_not_registered','player_quit','player_banned'].includes(profile.call_game_description)">
        {{profile.call_game_description | GetLabelPipe}}
      </div>

      <div *ngIf="['player_game_in_progress','me_game_in_progress','already_played','player_not_in_range'].includes(profile.call_game_description)">
        <ng-container *ngIf="profile.has_active_game">
          {{'cup_player_busy'|GetLabelPipe}}
        </ng-container>
        <ng-container *ngIf="!profile.has_active_game">
          {{('cup_player_free_but__'+profile.call_game_description) | GetLabelPipe}}
        </ng-container>
      </div>

      <div *ngIf="profile.id == application.user.id && ['mutual_game_in_progress','mutual_game_in_confirmation_vizavi_proposal','mutual_game_in_confirmation_my_proposal'].includes(profile.call_game_description)">
        {{('cup_profile_mutual_game__'+profile.call_game_description) | GetLabelPipe}}
      </div>
      <div *ngIf="profile.id != application.user.id && ['mutual_game_in_progress','mutual_game_in_confirmation_vizavi_proposal','mutual_game_in_confirmation_my_proposal'].includes(profile.call_game_description)">
        {{('cup_vizavi_mutual_game__'+profile.call_game_description) | GetLabelPipe}}
      </div>

      <div *ngIf="['player_available'].includes(profile.call_game_description)">
        {{'cup_player_available' | GetLabelPipe}}
      </div>

    </div>
  </ng-container>
  <br>
</div>
